const fr = {
    // Common
    'Close': 'Fermer',
    'From': 'De',
    'To': 'À',
    'Distance': 'Distance',
    'Estimated time': 'Heure d\'arrivée estimée',
    'Level': 'Niveau',
    'Search by name, category, building...': 'Recherche par nom, catégorie, bâtiment...',
    'Show legend': 'Afficher la légende',
    'Ask with AI': 'Demander à l\'IA',
    'Nothing was found': 'Rien n\'a été trouvé',
    'd': 'd',
    'h': 'h',
    'min': 'min',
    'Walk': 'À pied',
    'Bike': 'À vélo',
    'Transit': 'En transports',
    'Drive': 'Voiture',
    'Start wayfinding': 'Commencer la navigation',
    // Location Details
    'Read full description': 'Lire la description complète',
    // Locations list
    'Locations': 'Emplacements',
    'Directions not available': 'Itinéraire non disponible',
    'Start directions': 'Commencer la navigation',
    // Route instructions
    'Previous': 'Précédent',
    'Next': 'Suivant',
    'StepYofX': 'Étape {{activeStep}} sur {{totalSteps}}',
    // Route Instructions Step
    'You have arrived': 'Vous êtes arrivé',
    'Leave': 'Départ',
    'Park': 'Parc',
    'at': 'à',
    'Building': 'Bâtiment',
    'Venue': 'Lieu',
    'Take staircase to level': 'Prenez l\'escalier jusqu\'au niveau',
    'Take the ladder to level': 'Empruntez l\'escalier pour rejoindre le niveau',
    'Take elevator to level': 'Prenez l\'ascenseur jusqu\'au niveau',
    'Take escalator to level': 'Empruntez l\'escalier roulant jusqu\'au niveau',
    'Take wheelchair lift to level': 'Prenez l\'élévateur pour fauteuil roulant jusqu\'au niveau',
    'Take wheelchair ramp to level': 'Prenez la rampe pour fauteuil roulant jusqu\'au niveau',
    'Exit': 'Partir',
    'Enter': 'Entrer',
    'stops': 'arrêts',
    'and continue': 'et continuez',
    'Continue straight ahead': 'Continuez tout droit',
    'Go left': 'Tournez a gauche',
    'Go sharp left': 'Allez directement à gauche',
    'Go slight left': 'Allez légèrement à gauche',
    'Go right': 'Allez à droite',
    'Go sharp right': 'Allez directement à droite',
    'Go slight right': 'Allez légèrement à droite',
    'Turn around': 'Faite demi-tour',
    // Wayfinding component
    'Switch': 'Changer',
    'Avoid stairs and escalators': 'Éviter les escaliers et les escalators',
    'Include bus transportation': 'Inclure le transport en bus',
    'No route found': 'Aucun itinéraire trouvé',
    'My position': 'Ma position',
    'Go!': 'C\'est parti!',
    'Directions': 'Instructions',
    'Choose departure': 'Choisir le départ',
    'Choose destination': 'Choisir la destination',
    // Venue selector
    'Venues': 'Lieux',
    'Select venue': 'Sélectionner le lieu',
    'Current': 'Actuel',
    // QR code dialog
    'Scan QR code': 'Scanne le code QR',
    'Scan the QR code to see the route on your phone': 'Scannez le code QR pour voir l\'itinéraire sur votre téléphone',
    'Done': 'Fini',
    // Directions
    'Cancel route': 'Annuler l\'itinéraire',
    'Finish route': 'Terminer l\'itinéraire',
    // Share location link
    'Share': 'Partager',
    'Copy link': 'Copier le lien',
    'QR Code': 'Code QR',
    // Opening Hours
    'Open': 'Ouvert',
    'Closed': 'Fermé',
    'Expand opening hours': 'Développer les heures d\'ouverture',
    'Collapse opening hours': 'Réduire les heures d\'ouverture',
    // View Selector
    'Go to view': 'Afficher le plan',
    'Close view selector': 'Fermer le sélecteur de vue',
    // Language Selector
    'Select language': 'Sélectionner langue',
    // Accessibility
    'Increase text size to 200%': 'Augmenter la taille du texte à 200%',
    'Decrease text size to 100%': 'Réduire la taille du texte à 100%',
    // Map Controls
    'Zoom in': 'Zoom avant',
    'Zoom out': 'Zoom arrière',
    // Ask with AI - Usage Consent
    'Usage consent title': 'Ask with AI - Consentement d\'utilisation',
    'Usage consent message': 'Ask with AI vous aide à trouver des lieux et à vous orienter dans ce site grâce à l\'Intelligence Artificielle (IA). Bien que nous nous efforcions d\'être précis, l\'IA peut parfois se tromper. Veuillez vérifier les détails importants avant de vous mettre en route.',
    'Usage consent accept': 'Je comprends',
    'Usage consent decline': 'Refuser',
    'AI disclaimer': 'Ask with AI peut faire des erreurs. Vérifiez les détails importants avant de vous mettre en route.',
    // Location Consent
    'Location consent message': 'Pour fournir des itinéraires personnalisés et vous aider à découvrir ce qui se trouve à proximité, Ask with AI souhaite accéder à votre position. Le chat fonctionnera toujours sans connaître votre position, mais vous devrez spécifier un point de départ.',
    'Location consent accept': 'Autoriser',
    'Location consent decline': 'Refuser',
};

export default fr;
